import { Component, EventEmitter, Output, ElementRef, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-uid-mismatch-alert',
  templateUrl: `./uid-mismatch-alert.component.html`,
  styleUrls: [`./uid-mismatch-alert.component.scss`]
})
export class UidMismatchAlertComponent implements AfterViewInit, OnDestroy {
  @Output() confirmed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  
  // 组件配置属性
  title: string = '警告';
  message: string = '检测到本地UID与服务器不一致，请重新登录。';
  confirmLabel: string = '确定';
  cancelLabel: string = '取消';
  showCancel: boolean = false;
  
  private isOpen: boolean = false;
  private overlayElement: HTMLElement;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {}

  ngAfterViewInit(): void {
    this.overlayElement = this.elementRef.nativeElement.querySelector('.alert-overlay');
  }

  /**
   * 打开弹出框
   */
  open(parentElement?: HTMLElement): void {
    if (this.isOpen) return;
    
    this.isOpen = true;
    
    // 添加到DOM
    const container = parentElement || document.body;
    this.renderer.appendChild(container, this.elementRef.nativeElement);
    
    // 添加打开状态样式
    setTimeout(() => {
      if (this.overlayElement) {
        this.renderer.setStyle(this.overlayElement, 'display', 'flex');
      }
    }, 10);
  }

  /**
   * 关闭弹出框
   */
  close(): void {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    
    // 添加关闭动画
    if (this.overlayElement) {
      this.renderer.setStyle(this.overlayElement, 'animation', 'fadeOut 0.3s ease');
    }
    
    // 延迟移除DOM元素以完成动画
    setTimeout(() => {
      if (this.elementRef.nativeElement.parentNode) {
        this.renderer.removeChild(
          this.elementRef.nativeElement.parentNode, 
          this.elementRef.nativeElement
        );
      }
      this.closed.emit();
    }, 300);
  }

  /**
   * 确认操作
   */
  confirm(): void {
    this.confirmed.emit();
    this.close();
  }

  /**
   * 点击遮罩层关闭
   */
  onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  ngOnDestroy(): void {
    // 清理资源
    if (this.elementRef.nativeElement.parentNode) {
      this.renderer.removeChild(
        this.elementRef.nativeElement.parentNode, 
        this.elementRef.nativeElement
      );
    }
  }
}